import * as React from "react";
const TooltipProviderContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") TooltipProviderContext.displayName = "TooltipProviderContext";
function useTooltipProviderContext() {
  return React.useContext(TooltipProviderContext);
}
export {
  TooltipProviderContext,
  useTooltipProviderContext
};
//# sourceMappingURL=TooltipProviderContext.js.map
